import { render } from "./coursesHome.vue?vue&type=template&id=37477330&scoped=true&ts=true"
import script from "./coursesHome.vue?vue&type=script&lang=ts"
export * from "./coursesHome.vue?vue&type=script&lang=ts"

import "./coursesHome.vue?vue&type=style&index=0&id=37477330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37477330"]])

export default __exports__